<script>
export default {
  name: 'LoadingPayment'
}
</script>

<template>
  <div class="bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30 flex items-center justify-center">
    <div class="flex flex-col items-center">
      <div class="w-12 h-12 border-4 border-primary-700 border-t-transparent rounded-full animate-spin"></div>
      <p class="mt-4 text-lg font-semibold text-blue-200">
        Paiement en cours...
      </p>
    </div>
  </div>
</template>
